import type { SessionKind } from '../api/SessionKind';

/** Where each kind of session lands: a super admin on the tenant list, a business user on the overview. */
export const homeOf = (kind: SessionKind): string => (kind === 'platform' ? '/platform/tenants' : '/');
